import WorkshopMain from "@/views/workshop/views/WorkshopMain.vue"
import WorkshopAttendanceRoute from "@/views/workshop/views/workshop-attendance/router/workshop-attendance.route.js"
import WorkshopDiscounts from "@/views/workshop/views/workshop-discounts/router/workshop-discounts.route.js"

const routes = [
    {
        path: "/workshop/",
        name: "workshop",
        redirect: { name: "workshop-attendance" },
        meta: { module: 7 },
        component: WorkshopMain,
        children: [
            ...WorkshopAttendanceRoute,
            ...WorkshopDiscounts,
        ]
    },

];

export default routes;
